export const getErrorRoute = (error) => {
  switch (error) {
    case 'unauthenticated':
      return '/no-access';
    default:
      return '/not-found';
  }
};
